export function parseTitle(title?: string | null) {
  if (!title) return '喵御宅_MFuns, 兴趣至上的二次元社区'
  const gblen = getGbLen(title)
  if (gblen < 50) {
    title = title + '_喵御宅_MFuns'
  }
  const newGBLen = getGbLen(title)
  if (newGBLen < 50) {
    title = title + '_兴趣至上的二次元社区'
  }
  return title
}
